// QA-reviewed machine-draft labels for two real national Surgeon-family
// variants. The English specialist source labels are in roleFamilies.js.
// These ARE NOT professional translations or standalone clinical summaries;
// all 16 locales retain the existing patient-visible machine-translation notice.
// Any later professional i18next 'roles.items.<variant>.title' always wins.
export const JOURNEY_SURGICAL_SPECIALIST_MACHINE_TITLES = Object.freeze({
  ar: Object.freeze({neurosurgeon:'جرّاح الأعصاب',orthopaedic_surgeon:'جرّاح العظام'}),
  bn: Object.freeze({neurosurgeon:'নিউরোসার্জন',orthopaedic_surgeon:'অর্থোপেডিক সার্জন'}),
  es: Object.freeze({neurosurgeon:'Neurocirujano',orthopaedic_surgeon:'Cirujano ortopédico'}),
  fa: Object.freeze({neurosurgeon:'جراح مغز و اعصاب',orthopaedic_surgeon:'جراح ارتوپد'}),
  fr: Object.freeze({neurosurgeon:'Neurochirurgien',orthopaedic_surgeon:'Chirurgien orthopédiste'}),
  gu: Object.freeze({neurosurgeon:'ન્યુરોસર્જન',orthopaedic_surgeon:'ઓર્થોપેડિક સર્જન'}),
  it: Object.freeze({neurosurgeon:'Neurochirurgo',orthopaedic_surgeon:'Chirurgo ortopedico'}),
  pa: Object.freeze({neurosurgeon:'ਨਿਊਰੋਸਰਜਨ',orthopaedic_surgeon:'ਆਰਥੋਪੀਡਿਕ ਸਰਜਨ'}),
  pl: Object.freeze({neurosurgeon:'Neurochirurg',orthopaedic_surgeon:'Chirurg ortopeda'}),
  pt: Object.freeze({neurosurgeon:'Neurocirurgião',orthopaedic_surgeon:'Cirurgião ortopédico'}),
  ro: Object.freeze({neurosurgeon:'Neurochirurg',orthopaedic_surgeon:'Chirurg ortoped'}),
  so: Object.freeze({neurosurgeon:'Dhakhtarka qalliinka neerfaha',orthopaedic_surgeon:'Dhakhtarka qalliinka lafaha'}),
  tl: Object.freeze({neurosurgeon:'Siruhano sa utak at mga nerbiyos',orthopaedic_surgeon:'Siruhanong ortopediko'}),
  tr: Object.freeze({neurosurgeon:'Beyin ve sinir cerrahı',orthopaedic_surgeon:'Ortopedi cerrahı'}),
  ur: Object.freeze({neurosurgeon:'نیورو سرجن',orthopaedic_surgeon:'آرتھوپیڈک سرجن'}),
  zh: Object.freeze({neurosurgeon:'神经外科医生',orthopaedic_surgeon:'骨科医生'}),
});
export function journeySurgicalSpecialistMachineTitle(language, variantKey) {
  const lang=String(language || '').toLowerCase().split('-')[0];
  return JOURNEY_SURGICAL_SPECIALIST_MACHINE_TITLES[lang]?.[variantKey] || '';
}
